import { SITE_LEGAL_ENTITY_NAME } from "../config/siteBrand";

/** Legal copy for Selena Service — structured like a typical GDPR/terms page (general inspiration only). */

export const termsPageTranslations = {
  ro: {
    eyebrow: "Legal",
    title: "Termeni și Condiții",
    subtitle: "Politica de confidențialitate și protecția datelor cu caracter personal",
    updatedLabel: "Ultima actualizare:",
    updatedValue: "aprilie 2026",
    backHome: "Înapoi la pagina principală",
    disclaimer:
      "Textul are caracter informativ și nu înlocuiește consultanța juridică individuală. Pentru întrebări legate de serviciile din atelier, te rugăm să ne contactezi direct.",
    sections: [
      {
        title: "1. Dispoziții generale",
        paragraphs: [
          "Prezentele Termeni și Condiții reglementează utilizarea site-ului selenaservice.ro și a funcționalităților oferite online (informare despre servicii, formulare de contact/programare și preferințe privind cookie-urile).",
          "Prin continuarea utilizării Site-ului și transmiterea datelor prin formulare confirmi că ai luat la cunoștință aceste informații și că ești de acord cu prelucrarea datelor în scopurile descrise mai jos, în măsura în care este necesară consimțământul conform legislației aplicabile.",
        ],
      },
      {
        title: "2. Operatorul și date de contact",
        paragraphs: [
          `În sensul Regulamentului (UE) 2016/679 (GDPR), operatorul pentru datele colectate prin intermediul Site-ului este ${SITE_LEGAL_ENTITY_NAME}, cu punct de lucru în Slobozia, Str. General Magheru nr. 73, județul Ialomița.`,
          "Ne poți contacta folosind datele din secțiunea „Contact” a Site-ului (telefon și adresă). Pentru solicitări privind protecția datelor cu caracter personal poți folosi aceleași canale de comunicare sau adresa de e-mail folosită oficial pentru corespondența companiei.",
        ],
      },
      {
        title: "3. Tipuri de date prelucrate",
        paragraphs: [
          "În funcție de modul în care interacționezi cu Site-ul, pot fi prelucrate următoarele categorii de date:",
        ],
        bullets: [
          "Date de identificare și contact transmise prin formulare (nume, număr de telefon, adresă de e-mail);",
          "Detalii legate de solicitarea ta (serviciu dorit, marcă/model vehicul, mesaj liber, interval preferat);",
          "Date tehnice și de utilizare în limita cookie-urilor și modulelor activate în funcție de setările tale (de exemplu preferință limbă, înregistrări statistice agregate dacă ai acceptat categoria „analitică”);",
          "Date incluse automat în log-uri server (precum adresă IP, agent utilizator, marcă temporală orientativă), utilizate pentru securitate și diagnostic tehnic limitat în timp.",
        ],
      },
      {
        title: "4. Scopuri și temeiuri ale prelucrării",
        paragraphs: [
          "Prelucrăm datele pentru:",
        ],
        bullets: [
          "răspunsul la solicitările tale și gestionarea programărilor sau mesajelor trimise prin formulare (temei: executarea unui contract sau demersuri precontractuale la cererea ta / interes legitim pentru comunicarea operațională);",
          "respectarea obligațiilor legale aplicabile (temei: obligație legală);",
          "îmbunătățirea funcționării și securității Site-ului și limitarea abuzurilor (temei: interes legitim);",
          "analiza utilizării Site-ului și comunicarea statisticilor agregate, doar dacă ai acceptat cookie-urile/analiza în banner-ul dedicat (temei: consimțământ).",
        ],
      },
      {
        title: "5. Cookie-uri și preferințe",
        paragraphs: [
          "Site-ul folosește cookie-uri și tehnologii similare conform categoriei alese de tine în banner-ul „Cookie-uri”: strict necesare (pentru funcții esențiale), analitică/statistică și marketing (dacă sunt activate și dacă există astfel de module integrate).",
          "Îți poți modifica preferințele oricând din butonul „Setări cookie-uri” din subsolul paginii. Dezactivarea unor categorii poate afecta parțial funcții auxiliare ale Site-ului.",
        ],
      },
      {
        title: "6. Transfer către terți și durată",
        paragraphs: [
          "Datele nu sunt vândute. Pot fi transmise furnizorilor care ne prestează servicii strict necesare (ex.: găzduire web, infrastructură e-mail sau instrumente analitice alese), în condiții contractuale de confidențialitate și în limitele legii.",
          "Datele din formulare sunt păstrate pe durata necesară procesării solicitării și ulterior pentru termene rezonabile legate de dovezi operaționale și arhivă internă, respectând legislația aplicabilă în domeniu.",
        ],
      },
      {
        title: "7. Drepturile tale",
        paragraphs: [
          "În condițiile GDPR ai dreptul de acces, rectificare, ștergere („dreptul de a fi uitat”), restricționarea prelucrării, opoziție și portabilitate acolo unde este cazul, precum și dreptul de a retrage consimțământul pentru activități bazate pe consimțământ.",
          "Ai dreptul să depui o plângere la autoritatea de supraveghere:",
        ],
        bullets: [
          "Autoritatea Națională de Supraveghere a Prelucrării Datelor cu Caracter Personal (ANSPDCP), București — www.dataprotection.ro.",
        ],
      },
      {
        title: "8. Link-uri externe și răspundere",
        paragraphs: [
          "Site-ul poate conține link-uri către site-uri ale terților (de exemplu platforme publice sau furnizori). Nu suntem responsabili pentru politicile sau practicile de confidențialitate ale acelor site-uri.",
          "Informațiile prezentate pe Site au caracter orientativ și nu înlocuiesc consultarea directă în service pentru diagnoze finale sau oferte personalizate.",
        ],
      },
      {
        title: "9. Modificări",
        paragraphs: [
          "Ne rezervăm dreptul de a actualiza această pagină pentru a reflecta modificări legislative sau operaționale. Versiunea în vigoare este cea afișată pe Site cu mențiunea ultimei actualizări.",
        ],
      },
    ],
  },
  en: {
    eyebrow: "Legal",
    title: "Terms & Conditions",
    subtitle: "Privacy notice & personal data protection",
    updatedLabel: "Last updated:",
    updatedValue: "April 2026",
    backHome: "Back to homepage",
    disclaimer:
      "This page is provided for general information only and does not replace individual legal advice. For workshop-related questions, please contact us directly.",
    sections: [
      {
        title: "1. General provisions",
        paragraphs: [
          "These Terms govern use of selenaservice.ro (information about services, contact/booking forms and cookie preferences).",
          "By continuing to use the website and submitting forms you acknowledge this notice and agree to processing where consent or another lawful basis applies.",
        ],
      },
      {
        title: "2. Data controller & contact",
        paragraphs: [
          `For personal data collected via the website, the controller is ${SITE_LEGAL_ENTITY_NAME}, located at 73 General Magheru Street, Slobozia, Ialomița County, Romania.`,
          "You can reach us via the Contact section on the site. Use the same channels or our official email address for privacy-related requests.",
        ],
      },
      {
        title: "3. Categories of data",
        paragraphs: ["Depending on how you use the site we may process:"],
        bullets: [
          "Identification/contact details submitted via forms (name, phone, email);",
          "Details about your request (service, vehicle notes, optional message, preferred slot);",
          "Technical/usage data limited to cookies/modules enabled under your preferences;",
          "Standard server logs (e.g. IP, user-agent, timestamps) for security and troubleshooting.",
        ],
      },
      {
        title: "4. Purposes & lawful bases",
        paragraphs: ["We process data to:"],
        bullets: [
          "Respond to enquiries and booking requests (contract / pre-contract steps / legitimate interests);",
          "Comply with legal obligations;",
          "Maintain security and integrity of the website (legitimate interests);",
          "Run aggregated analytics only if you accepted the analytics cookie category (consent).",
        ],
      },
      {
        title: "5. Cookies",
        paragraphs: [
          "Cookies are managed via our cookie banner (necessary, analytics, marketing where applicable). You can reopen preferences anytime via “Cookie settings” in the footer.",
        ],
      },
      {
        title: "6. Recipients & retention",
        paragraphs: [
          "We do not sell personal data. Processors such as hosting or email providers may receive limited data under confidentiality obligations.",
          "Form data is kept only as long as needed to handle your request and for reasonable operational/legal retention periods.",
        ],
      },
      {
        title: "7. Your rights",
        paragraphs: [
          "Under GDPR you may exercise access, rectification, erasure, restriction, objection and portability where applicable, and withdraw consent for consent-based processing.",
          "You may lodge a complaint with your supervisory authority — in Romania: ANSPDCP (www.dataprotection.ro).",
        ],
      },
      {
        title: "8. External links & liability",
        paragraphs: [
          "Third-party sites linked from our pages have their own policies; we are not responsible for their practices.",
          "Site content is indicative and does not replace an on-site inspection or personalised quote.",
        ],
      },
      {
        title: "9. Changes",
        paragraphs: [
          "We may update this page to reflect legal or operational changes. The latest version is always the one shown here with the updated date.",
        ],
      },
    ],
  },
  uk: {
    eyebrow: "Юридичне",
    title: "Умови використання та конфіденційність",
    subtitle: "Політика конфіденційності та захист персональних даних",
    updatedLabel: "Оновлено:",
    updatedValue: "квітень 2026",
    backHome: "На головну",
    disclaimer:
      "Сторінка має загальний інформаційний характер і не замінює індивідуальну юридичну консультацію. З питань щодо послуг автосервісу звертайтеся безпосередньо до нас.",
    sections: [
      {
        title: "1. Загальні положення",
        paragraphs: [
          "Ці умови регулюють використання сайту selenaservice.ro (інформація про послуги, форми запису/зв'язку та налаштування cookie).",
          "Продовжуючи використання сайту та надсилаючи форми, ви підтверджуєте ознайомлення з цим текстом і згоду на обробку даних там, де це потрібно.",
        ],
      },
      {
        title: "2. Володілець даних та контакт",
        paragraphs: [
          `Володільцем персональних даних, зібраних через сайт, є ${SITE_LEGAL_ENTITY_NAME}, адреса: Слобозія, вул. General Magheru 73, повіт Яломіца, Румунія.`,
          "Зв'язатися можна через розділ «Контакт». Для запитів щодо захисту даних використовуйте ті самі канали або офіційну електронну пошту компанії.",
        ],
      },
      {
        title: "3. Які дані обробляємо",
        paragraphs: ["Залежно від вашої взаємодії з сайтом можуть оброблятися:"],
        bullets: [
          "Ім'я, телефон, email із форм;",
          "Деталі заявки (послуга, авто, повідомлення, бажаний час);",
          "Технічні дані в межах cookie та модулів, які ви увімкнули;",
          "Журнали сервера (IP, user-agent тощо) для безпеки та діагностики.",
        ],
      },
      {
        title: "4. Цілі та правові підстави",
        paragraphs: ["Обробка здійснюється для:"],
        bullets: [
          "відповіді на запити та організації запису;",
          "виконання законних обов'язків;",
          "безпеки сайту;",
          "аналітики лише за вашої згоди (категорія cookie «Аналітика»).",
        ],
      },
      {
        title: "5. Cookie",
        paragraphs: [
          "Cookie керуються банером на сайті; налаштування можна змінити через «Налаштування cookie» у підвалі сторінки.",
        ],
      },
      {
        title: "6. Треті сторони та зберігання",
        paragraphs: [
          "Дані не продаються. Обмежений доступ можуть мати провайдери хостингу, пошти тощо за договорами конфіденційності.",
          "Термін зберігання — лише стільки, скільки потрібно для обробки запиту та дотримання закону.",
        ],
      },
      {
        title: "7. Ваші права",
        paragraphs: [
          "Згідно з GDPR ви можете реалізувати права доступу, виправлення, видалення, обмеження, заперечення та перенесення даних, а також відкликати згоду.",
          "Скаргу можна подати до наглядового органу — у Румунії: ANSPDCP (www.dataprotection.ro).",
        ],
      },
      {
        title: "8. Зовнішні посилання",
        paragraphs: [
          "Посилання на сторонні ресурси мають власні політики; ми не контролюємо їхню обробку даних.",
          "Матеріали сайту мають ознайомлювальний характер.",
        ],
      },
      {
        title: "9. Зміни",
        paragraphs: ["Ми можемо оновлювати цю сторінку; актуальна версія завжди з датою оновлення вище."],
      },
    ],
  },
};
